import { render } from "./blog_detail.vue?vue&type=template&id=566c2a27"
import script from "./blog_detail.vue?vue&type=script&lang=js"
export * from "./blog_detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__